import React from 'react'
import { Share } from '@material-ui/icons'
import { IEditionMetadata, IPromotedTo } from '../../types/pack'
import { Space } from '../../layouts'
import { H2, P } from '../../components'
import { StyledLocationDetail } from './styled'

export interface ISharingDetails {
  edition: IEditionMetadata
  isPromotedTo: IPromotedTo
}

export const SharingDetails = ({ edition, isPromotedTo }: ISharingDetails) =>
  edition ? (
    <StyledLocationDetail>
      <header>
        <H2>Sharing</H2>
        <Space pl={2}>
          <Share
            className="auto-sharing-icon"
            fontSize="small"
            color="primary"
          />
        </Space>
      </header>
      <P>
        {isPromotedTo.LynxEvents && isPromotedTo.Portal
          ? 'This file will appear in Portal Search and Lynx Events'
          : isPromotedTo.LynxEvents
          ? 'This file will appear in Lynx Events'
          : isPromotedTo.Portal
          ? 'This file will appear in Portal Search'
          : 'This file is hidden from Portal Search and Lynx Events'}
      </P>
    </StyledLocationDetail>
  ) : null
